<p-card>
  <div class="container">
      <div class="aviso">
          <i class="pi pi-exclamation-triangle pi-fw" style="font-size: 2rem"></i>
          <h4><strong>"{{titulo}}"</strong></h4>
          <p><strong>"{{texto}}"</strong></p>
          <p *ngIf="recurso">"{{recurso}}"</p>
      </div>
  </div>
</p-card>
